<template>
<div class="px-4 sm:px-8 lg:px-0">
    <div class="mx-auto my-12 w-full max-w-[1136px] bg-white rounded-lg px-6 py-12 sm:px-8">
        <div class="flex flex-col items-center text-center text-main">
            <img :src="pendingImg" alt="" class="w-[200px] h-[200px]" />
            <div class="flex flex-col items-center gap-4 py-8 w-full">
                <h1 class="font-bold text-2xl leading-8">チャンネル申請を受け付けました</h1>
                <div class="text-sm leading-5">
                    <p>記事が投稿できるようになりましたら、登録いただいたメールアドレスにお知らせします。</p>
                    <p v-if="applicationEmail" class="break-all">{{ applicationEmail }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import pendingImg from '@/assets/channel_application_pending.svg';

const store = useStore();

const applicationEmail = computed(() => store.state.applicationEmail);
</script>
